import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { requestCreateInitialPerson } from '../../../api/registration/registration.actions';

import SignUp from '../../../components/screens/auth/sign-up/SignUp';

const SignUpContainer = () => {
  const [successfulReg, setSuccessfulReg] = useState(false);

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const email = searchParams.get('email');

  const register = (details) => {
    dispatch(
      requestCreateInitialPerson({
        initialPerson: details,
        onSuccess: () => setSuccessfulReg(true),
      })
    );
  };

  return <SignUp register={register} successfulReg={successfulReg} initialEmail={email} />;
};

export default SignUpContainer;
